<template>
  <a class="arrow lightboxPrev" :href="previous"><i class="fas fa-arrow-left"></i></a>
</template>

<script>
export default {
  name: 'LightboxPrev',
  props: ['previous']
}
</script>
